import { ComboBox, ComboBoxProps } from '@progress/kendo-react-dropdowns'
import { Error } from '@progress/kendo-react-labels'
import { useEffect } from 'react'

import type { FieldRenderProps } from '@progress/kendo-react-form'

import { useGeovisualizadoresStore } from '../../../stores/geovisualizador'

export default function ValidatedShareModalCombobox(
  fieldRenderProps: FieldRenderProps
) {
  const setShareModalIsValid = useGeovisualizadoresStore(
    (state) => state.setShareModalIsValid
  )
  const addShareModalValidatedField = useGeovisualizadoresStore(
    (state) => state.addShareModalValidatedField
  )

  useEffect(() => {
    setShareModalIsValid(!!fieldRenderProps.value)
    addShareModalValidatedField({
      [fieldRenderProps.name]: !!fieldRenderProps.value,
    })
  }, [fieldRenderProps.value])

  return (
    <div>
      <ComboBox {...(fieldRenderProps as ComboBoxProps)} />
      {fieldRenderProps.visited && fieldRenderProps.validationMessage && (
        <Error>{fieldRenderProps.validationMessage}</Error>
      )}
    </div>
  )
}
